module.exports = __webpack_public_path__ + "static/media/whoop-pack-shot.5a23dfd5.png";